import React from 'react';
import { PropTypes as PT } from 'prop-types';
import classes from './CallOverlaySlide.module.scss';

const CallOverlaySlide = (props) => {
  const {
    slide,
    isMinimized,
    videoWidth,
    videoContainerWidth,
  } = props;

  return (
    <div
      className={classes.slideContainer}
      style={{ width: isMinimized ? '100%' : videoContainerWidth }}
    >
      <img
        src={slide}
        className={classes.slide}
        style={{ width: isMinimized ? '100%' : videoWidth }}
        alt=""
      />
    </div>
  );
};

CallOverlaySlide.propTypes = {
  slide: PT.string.isRequired,
  isMinimized: PT.bool.isRequired,
  videoWidth: PT.number,
  videoContainerWidth: PT.number,
};

export default CallOverlaySlide;
